import _components, { registerComponents } from './components/formComponents';
import _previewcomponents, { registerPreviewComponents } from './components/preview/previewComponents';
import _filters, { registerFilters } from './filters';
import _formMixin from './mixins/formMixin';
import _previewMixin from './mixins/previewMixin';

export const formMixin = _formMixin;
export const previewMixin = _previewMixin;
export const components = _components;
export const previewComponents = _previewcomponents;
export const filters = _filters;

if (typeof window !== 'undefined') {
  window.formComponents = window.fc = components;
  window.previewComponents = window.pc = previewComponents;
  window.formMixin = formMixin;
  window.previewMixin = previewMixin;
  if (window.Vue) {
    if (!window.Vue.config.skipGlobalComponents) {
      registerComponents(window.Vue);
      registerPreviewComponents(window.Vue);
    } else {
      console.log('GlobalComponents: skipped');
    }
    registerFilters(window.Vue);
  }
}

export default components;
